import { render } from "./cursor.vue?vue&type=template&id=0355ef8a"
import script from "./cursor.vue?vue&type=script&lang=js"
export * from "./cursor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__